export const PRIVACY_POLICY = 'https://micin.jp/privacy'

export const CLINIC_TERMS = 'https://about.curon.co/terms/clinic'

export const EXTERNAL_TRANSMISSION = 'https://curon.co/assets/external_transmission.pdf'

export const SMS_PINCODE_HELP = 'https://micin.my.site.com/FAQforCuronsmartpass/s/article/1770'

export const AI_CHAT_FAQ =
  'https://miibo.jp/chat/8a17e053-2895-4659-bc6a-d0ae04a5339c198794feea53e0?name=%E3%82%AF%E3%83%AD%E3%83%B3%20AI%E3%82%A2%E3%82%B7%E3%82%B9%E3%82%BF%E3%83%B3%E3%83%88'

export const FAQ_FOR_DOCTORS = 'https://micin.my.site.com/FAQforDoctors/s/'

export const FAQ_FOR_CURON_SMARTPASS = 'https://micin.my.site.com/FAQforCuronsmartpass/s/'
